import Immutable from 'seamless-immutable';
import { SET_NAV_GROUP } from '../components/customerActionsTemplate/customer.actions.template.actions';
export var INITIAL_STATE = Immutable({
  selectedNavGroup: null
});
export default function customerActionsTemplateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case SET_NAV_GROUP:
      return state.set('selectedNavGroup', state.selectedNavGroup === payload.id ? null : payload.id);
    default:
      return state;
  }
}